import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import { PageHeader, EmptyState, Loader } from "@/components/common";
import { fmtDate } from "@/lib/format";
import { Card } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { Scroll } from "@phosphor-icons/react";

export default function Audit() {
  const [items, setItems] = useState(null);
  useEffect(() => { api.get("/audit-logs").then((r) => setItems(r.data)); }, []);
  if (!items) return <Loader />;

  return (
    <div>
      <PageHeader title="Audit Logs" subtitle="User activity across the system" icon={Scroll} />
      {items.length === 0 ? (
        <EmptyState icon={Scroll} title="No activity yet" message="User actions will be logged here." />
      ) : (
        <Card className="overflow-hidden">
          <div className="overflow-x-auto">
            <Table>
              <TableHeader><TableRow>
                <TableHead>When</TableHead><TableHead>User</TableHead><TableHead>Action</TableHead>
                <TableHead>Entity</TableHead><TableHead>Details</TableHead>
              </TableRow></TableHeader>
              <TableBody>
                {items.map((l) => (
                  <TableRow key={l.id} data-testid={`audit-row-${l.id}`}>
                    <TableCell className="text-sm whitespace-nowrap">{fmtDate(l.created_at)}</TableCell>
                    <TableCell className="text-sm">{l.user_name}<div className="text-xs text-muted-foreground capitalize">{String(l.user_role).replace(/_/g, " ")}</div></TableCell>
                    <TableCell><Badge variant="outline" className="capitalize">{l.action}</Badge></TableCell>
                    <TableCell className="capitalize text-sm">{l.entity}</TableCell>
                    <TableCell className="text-sm text-muted-foreground">{l.details || "—"}</TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </div>
        </Card>
      )}
    </div>
  );
}
